import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "user-info flex-center-col",
  id: "user-info"
};
const _hoisted_2 = {
  key: 0,
  class: "absolute -right-[40px] top-0 h-full flex items-center"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "vip-icon"
};
import { onMounted, ref } from "vue";
import { httpGet, httpPost, httpPut } from "@/utils/http";
import { ElMessage } from "element-plus";
import { Plus, UserFilled, Select } from "@element-plus/icons-vue";
import Compressor from "compressorjs";
import { dateFormat } from "@/utils/libs";
import { checkSession } from "@/store/cache";
import { useRouter } from "vue-router";
import Icon from "./Icon/src/Icon.vue";
export default {
  __name: 'UserProfile',
  props: {
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ["hide"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const user = ref({
      vip: false,
      username: "演示数据",
      nickname: "演示数据",
      avatar: "/images/menu/member.png",
      mobile: "演示数据",
      power: 99999
    });
    const vipImg = ref("/images/menu/member.png");
    const router = useRouter();
    const emits = __emit;
    onMounted(() => {
      checkSession().then(() => {
        // 获取最新用户信息
        // httpGet("/user/profile")
        httpGet("/system/user/profile/session").then(res => {
          user.value = res;
        }).catch(e => {
          ElMessage.error("获取用户信息失败：" + e.message);
        });
      }).catch(e => {
        console.log(e);
      });
    });
    const afterRead = file => {
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/upload", formData).then(res => {
            user.value.avatar = res.data.url;
            ElMessage.success({
              message: "上传成功",
              duration: 500
            });
          }).catch(e => {
            ElMessage.error("图片上传失败:" + e.message);
          });
        },
        error(err) {
          console.log(err.message);
        }
      });
    };
    const save = () => {
      // httpPost("/user/profile/update", user.value)
      httpPut("/system/user/profile/updateUserProfileInfo", user.value).then(() => {
        ElMessage.success({
          message: "更新成功",
          duration: 500
        });
      }).catch(e => {
        ElMessage.error("更新失败：" + e.message);
      });
    };
    const gotoLog = () => {
      router.push("/powerLog");
      emits("hide", false);
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        model: user.value,
        "label-width": "80px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [false ? (_openBlock(), _createBlock(_component_el_upload, {
            key: 0,
            class: "avatar-uploader",
            "auto-upload": true,
            "show-file-list": false,
            "http-request": afterRead,
            accept: ".png,.jpg,.jpeg,.bmp"
          }, {
            default: _withCtx(() => [user.value.avatar ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              content: "点击上传头像",
              placement: "top"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_avatar, {
                src: user.value.avatar,
                shape: "circle",
                size: 100
              }, null, 8, ["src"])]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 1,
              class: "avatar-uploader-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            }))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "avatar-uploader-icon !text-[48px] !text-gray-400"
          }, {
            default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
            _: 1
          }))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "昵称",
          class: "relative w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: !__props.edit,
            modelValue: user.value['nickname'],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => user.value['nickname'] = $event)
          }, null, 8, ["disabled", "modelValue"]), __props.edit ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_tooltip, {
            content: "保存修改",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              text: "",
              size: "small",
              dark: false,
              type: "primary",
              onClick: save
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Select))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "账号"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(user.value.mobile), 1), _createVNode(_component_el_tooltip, {
            class: "box-item",
            content: "您已经是 VIP 会员",
            placement: "right"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_4, [user.value.vip ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              src: vipImg.value,
              class: "rounded-full ml-1 size-5"
            }, null, 8, ["src"])) : _createCommentVNode("", true)])]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "剩余算力"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            type: "warning"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(user.value["power"]), 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "info",
            size: "small",
            class: "ml-2 cursor-pointer",
            onClick: gotoLog
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("算力日志")])),
            _: 1
          })]),
          _: 1
        }), user.value['expired_time'] > 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "会员到期时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tag, {
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(dateFormat)(user.value["expired_time"])), 1)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};